module.exports = __webpack_public_path__ + "static/media/cart_rounded.13c2edb6.svg";